export function isBlankFieldValue(value) {
    if (value === undefined || value === null)
        return true;
    return typeof value === 'string' && value.trim() === '';
}
//# sourceMappingURL=is-blank-field-value.js.map